const API_BASE_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000/api" : "/api";
const API_KEY = process.env.REACT_APP_X_API_KEY.trim();

/**
 * Global fetch wrapper (ALL endpoints use x-api-key)
 */
async function apiFetch(endpoint, options = {}) {
    const res = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: options.method || 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY,
            ...(options.headers || {}),
        },
        body: options.body ? JSON.stringify(options.body) : undefined,
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(`API Error ${res.status}: ${text}`);
    }

    return res.json();
}

/* =======================
   CONTENT
======================= */

/** GET /api/content */
export function getContent() {
    return apiFetch('/content');
}

/** POST /api/content/refresh */
export function refreshContent() {
    return apiFetch('/content/refresh');
}

/* =======================
   CONTACT
======================= */

/**
 * POST /contact-us
 * @param {Object} form
 * @param {string} form.name
 * @param {string} form.email
 * @param {string} form.subject
 * @param {string} form.message
 */
export function sendContactMessage(form) {
    return apiFetch('/contact/contact-us', {
        method: 'POST',
        body: form,
    });
}
